import { TextButton } from '@zillow/constellation-10';
import { StyledContainer } from '@zg-rentals/zrs-comet';
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContextProvider';

const ViewLeads = (): JSX.Element => {
  const { paths } = useContext(AppContext);
  return (
    // @ts-expect-error
    <StyledContainer borderBottom paddingY={3.45} paddingX={3}>
      <TextButton asChild textStyle="body-sm-bold">
        <a href={paths.leadsPage}>View leads</a>
      </TextButton>
    </StyledContainer>
  );
};

export default ViewLeads;
